import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Configuration des titres par route
const PAGE_TITLES: Record<string, string> = {
  '/': 'SimulReno - Accueil - Estimation travaux de rénovation',
  '/quick-estimate': 'SimulReno - Estimation rapide gratuite',
  '/estimation/nouvelle': 'SimulReno - Estimation détaillée',
  '/dashboard': 'SimulReno - Tableau de bord - Mes estimations',
  '/profile': 'SimulReno - Mon profil',
  '/credits/purchase': 'SimulReno - Acheter des crédits',
  '/credits/confirmation': 'SimulReno - Confirmation de paiement',
  '/login': 'SimulReno - Connexion',
  '/register': 'SimulReno - Inscription',
  '/forgot-password': 'SimulReno - Mot de passe oublié',
  '/contact': 'SimulReno - Contact',
  '/mentions-legales': 'SimulReno - Mentions légales',
  '/admin': 'SimulReno - Administration',
  '/coming-soon': 'SimulReno - Bientôt disponible'
};

// Titre par défaut
const DEFAULT_TITLE = 'SimulReno - Évaluez vos travaux en 5 min, sans faire venir d\'artisan';

/**
 * Hook pour gérer les titres de page dynamiques
 * Met à jour automatiquement le titre HTML selon la route
 */
export const usePageTitle = (customTitle?: string) => {
  const location = useLocation();

  useEffect(() => {
    let title = DEFAULT_TITLE;

    if (customTitle) {
      // Titre personnalisé fourni
      title = `SimulReno - ${customTitle}`;
    } else {
      // Recherche du titre basé sur la route
      const exactMatch = PAGE_TITLES[location.pathname];
      if (exactMatch) {
        title = exactMatch;
      } else {
        // Recherche de correspondances partielles pour les routes dynamiques
        const pathSegments = location.pathname.split('/');
        
        if (pathSegments.includes('estimation') && pathSegments.includes('view')) {
          title = 'SimulReno - Consultation d\'estimation';
        } else if (pathSegments.includes('estimation') && pathSegments.includes('edit')) {
          title = 'SimulReno - Modification d\'estimation';
        } else if (pathSegments.includes('estimation')) {
          title = 'SimulReno - Estimation détaillée';
        } else if (pathSegments.includes('admin')) {
          title = 'SimulReno - Administration';
        }
      }
    }

    // Mettre à jour le titre HTML
    document.title = title;
  }, [location.pathname, customTitle]);

  return document.title;
};

/**
 * Hook pour définir un titre personnalisé pour une page spécifique
 */
export const useCustomPageTitle = (title: string) => {
  usePageTitle(title);
};